import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";

function AppFooter(props) {
  return (
    <Stack direction="column" spacing={1} sx={{ mt: 1, mb:2, p: 3 }}>
      <Typography
        variant="body1"
        color="text.secondary"
        align="center"
        {...props}
      >
          {process.env.REACT_APP_BUSINESS_ADDRESS}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        align="center"
        {...props}
      >
          {process.env.REACT_APP_BUSINESS_EMAIL}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        align="center"
        {...props}
      >
        {"Copyright © "}
        <Link color="inherit" href={process.env.REACT_APP_BUSINESS_WEBSITE || "#"}>
            {process.env.REACT_APP_BUSINESS_NAME}
        </Link>{" "}
        {new Date().getFullYear()}
        {"."}
      </Typography>
    </Stack>
  );
}
export default AppFooter;
